module.exports = __webpack_public_path__ + "static/media/bali.a1725974.jpeg";